<template>
  <v-card class="card-info px-2" outlined id="amountcard" height="108px">
    <v-row no-gutters align="center" class="fill-height">
      <v-col
        cols="auto"
        class="fill-height d-flex align-center justify-center py-3"
      >
        <v-row
          style="width: 80px; height: 80px;"
          :class="colour"
          class="fill-height br-10 mx-1"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            class="fill-height d-flex align-center icon text--white justify-center"
          >
            <icon-budget v-if="typeCard === 1"></icon-budget>
            <icon-spending v-if="typeCard === 2"></icon-spending>
            <icon-remaining v-if="typeCard === 3"></icon-remaining>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pl-1">
        <v-row dense justify="space-between" align="center">
          <v-col cols="8">
            <div class="fs-12 font-weight-700 lh-12" :class="textColor">
              {{ text }}
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="text-right red--text py-0 title-percent title right-text"
            v-if="typeCard !== 1"
          >
            <percentage-spending
              v-if="typeCard === 2"
              :val1="value1"
              :val2="valueTotal"
              class="right-text"
            ></percentage-spending>
            <percentage-remaining
              class="right-text"
              v-if="typeCard === 3"
              :val1="value1"
              :val2="valueTotal"
            ></percentage-remaining>
          </v-col>
        </v-row>
        <v-row dense class="total">
          <v-col>
            {{ currFormatter(value1) || '-' }}
            <span class="curr">BIDR</span>
          </v-col>
        </v-row>
        <v-row dense class="total-eur">
          <v-col> {{ eur(valueEur) || '-' }} MEUR </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import IconBudget from '../iconAmount/iconBudget';
import IconSpending from '../iconAmount/iconSpending';
import IconRemaining from '../iconAmount/iconRemaining';
import PercentageSpending from '../percentageCard/spending';
import PercentageRemaining from '../percentageCard/remaining';

export default {
  components: {
    'icon-budget': IconBudget,
    'icon-spending': IconSpending,
    'icon-remaining': IconRemaining,
    'percentage-spending': PercentageSpending,
    'percentage-remaining': PercentageRemaining
  },
  props: {
    typeCard: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    value1: {
      type: Number,
      required: true
    },
    valueTotal: {
      type: Number,
      required: false
    },
    valueEur: {
      type: Number,
      required: true
    },
    colour: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    }
  }
};
</script>
